import HeaderDefaultStyle from '@/styles/components/careers/header/_index.module.scss';
import EditIcon from 'public/icons/career_icons/edit.svg';
import BarsIcon from 'public/icons/career_icons/bars.svg'
import { LINK_TYPES } from '@/imports-files/pages/career/customize-career-page';
import { useRef, Button, useState, Tooltip, CommonAction} from '@/imports-files/pages/career/customize-career-page';


export function Header({formik, customizeCareerAction, isPreview, isPublic, headerClass, logoClass}){
  const commonAction = new CommonAction();
  const headerLinks = formik.values.career_navigation_links_attributes.filter((navigation) => !navigation._destroy && (navigation.navigation_type == LINK_TYPES.header) )
  const headerLinks_with_name = headerLinks.filter((x) => x.name).length
  function headerStyle(isPreview, isPublic, formik) {
   const style = {}
   return isPreview && !isPublic && formik.values.unpublish_change ? { top: window.innerWidth <= 600 ? '50px' : '20px' } : {}
  }

  return(
    <div className = {`${HeaderDefaultStyle.CareerMainHeader} ${headerClass}`}>
    {isPreview && !isPublic && formik.values.unpublish_change && <div className = {`${HeaderDefaultStyle.NarrowBanner}`}>
        <p><img src ="/icons/error.png"></img> Your changes have not been published. Please press “Publish” to go live with your changes.</p>
      </div>}
    <div id = "careerHeaderDiv" className = {`${HeaderDefaultStyle.CareerHeader} ${HeaderDefaultStyle.CareerHeaderPreview}`} style={headerStyle(isPreview, isPublic, formik)}>
    <div className = {`${HeaderDefaultStyle.CareerHeader__DFlex}`}>
      <div className = {`${HeaderDefaultStyle.CareerHeader__Logo} ${logoClass}`}>
        <img src={formik.values.logo_url ? formik.values.logo_url : "/images/logo/Career_Default_Logo.png"} alt="Career Logo"></img>
        {!isPreview && <span className = {`${HeaderDefaultStyle.CareerHeader__Logo__EditIcon}`}>
            <input id   =   ""
             accept     =   ".png, .jpg, .jpeg"
             type       =   "file"
             onChange   =   { (event) => customizeCareerAction.handleLogoOnChange(event, formik)}
             title     = {customizeCareerAction.imageInfoContent('logo_image')}
             />
            <EditIcon />
        </span>}
      </div>
       {isPreview && headerLinks_with_name > 0 &&
        <div className = {`${HeaderDefaultStyle.CareerHeader__BarsIcon}`}>
         <a onClick={(event) => customizeCareerAction.toggleMenu()}>
             <div className={`Hamburger`}>
              <span className={`Hamburger__Line`}></span>
              <span className={`Hamburger__Line`}></span>
              <span className={`Hamburger__Line`}></span>
            </div>
          </a>
        </div>
        }
       </div> 
      <div className = {`${HeaderDefaultStyle.CareerHeader__Links} careerHeaderBlock`}>
        <ul>
          {headerLinks.map((headerLink, index) => {
            return (headerLink.name && <li key={`h_link_${index}`} className = {`${HeaderDefaultStyle.CareerHeader__Links__Li}`}
              >
              {headerLink.url ? <a style={customizeCareerAction.headerStyle(formik)} href = {commonAction.addHttpOrHttps(headerLink.url)} target={"_blank"}>{headerLink.name}</a> : <a style={customizeCareerAction.headerStyle(formik)}>{headerLink.name}</a>}
              </li>)
          }
          )}
        </ul>
      </div>
    </div>
    </div>
  )
}